<template lang="html">
  <div>
    <md-layout>
      <md-layout md-flex="100">
        <Banner
          width="1024px"
          height="400px"
          bordered
          duration="1000ms"
          autoplay
          :pagination="pagination"
          show-navigation
          disable-on-hover
          mode="loop"
          v-if="bannersReady"
        >
          <Slide v-for="banner in banners">
            <img
               :src="`${parametros.ruta_imagen}${banner.link}`" 
            />
          </Slide>
        </Banner>
      </md-layout>
      <md-layout md-align="center" style="margin-top:50px">
        <md-layout style="max-width:1024px" md-gutter="16" v-if="categoriasReady">

          <md-layout style="margin-top:30px" md-flex="20" md-flex-small="100" md-flex-xsmall="100" md-align="center" v-for="(categoria, index) in categorias"> 
            <span style="text-align:center; cursor:pointer" @click="goCategoria(categoria)">
            <!-- <img style="width:150px"
              :src="`${categoria.foto}`"
            /> -->
            <img v-if="categoria.foto || categoria.foto.replace(/ /g,'') !== '' " style="width:155px; height:155px"
              :src="`${parametros.ruta_imagen}${categoria.foto}`"
            />
            <img id="" v-else src="../../assets/img/SuperticketElefanteC.png" alt="No se encontro la imagen" style="z-index:99"/>
            {{categoria.descripcion}}
            </span>
          </md-layout>

        </md-layout>
      </md-layout>

      <md-layout md-align="center" style="margin-top:70px" md-flex="100">
        <md-layout style="max-width:1024px" md-gutter="16" v-if="articuloReady">
          <md-layout md-flex="100">
          <h2>
            Ofertas Destacadas
          </h2>
          </md-layout>
        <md-layout
            md-flex-xlarge="20"
            md-flex-large="20"
            md-flex-medium="33"
            md-flex-small="100"
            md-flex-xsmall="100"
            v-for="(articulo, index) in articulos" 
            v-if="articulo.precio > 0"
            :ref="index"
            :key="index"
            >
            <span style="cursor:pointer" @click="goArticulos(articulo)">
              <md-card class="articulo-card">
                <md-card-header>
                  <md-card-header-text>
                    <div class="md-subhead" style="font-size:14px">{{articulo.clave}}</div>
                    <div class="md-title" style="min-height:80px; max-height:80px; font-size:12px; line-height: 14px;">
                      <!-- {{articulo.descripcion}} -->
                      {{articulo.descripcion.substring(0, 100)}} {{articulo.descripcion.trim().length > 100 ? '...' : ''}}
                      <md-tooltip>
                        {{articulo.descripcion}}
                      </md-tooltip>
                    </div>
                  </md-card-header-text>

                  </md-card-header>

                    <md-card-media style="min-height:150px;">
                      <md-layout md-align="center" style="padding:10px;">
                        <!-- <img id="" :src="articulo.foto" :alt="articulo.foto" /> -->
                        <img :id="`img${index}`" v-if="articulo.foto && articulo.foto.replace(/ /g,'') !== '' && articulo.foto.replace(/ /g,'') !== null" :src="`${parametros.ruta_imagen}${articulo.foto}`"  style="z-index:99"/>
                        <img id="" v-else src="../../assets/img/SuperticketElefanteC.png" alt="No se encontro la imagen" style="z-index:99"/>
                      </md-layout>
                    </md-card-media>

                    <md-card-content>
                      <!-- <md-layout class="descripcion">
                      {{articulo.observacion}}
                      </md-layout> -->
                      <md-layout md-align="end" style="min-height:40px; max-height:40px">
                        <md-layout md-align="center" md-flex="100">
                          <label class="precioNormal" v-if="parametros.ocultar_precios == 0 || isLogged">
                              {{articuloPrecio(articulo.precioAnt)}}                   
                          </label>
                        </md-layout>
                        <md-layout md-align="center" md-flex="100">
                          <label class="precio" v-if="parametros.ocultar_precios == 0 || isLogged">
                              {{articuloPrecio(articulo.precio)}}                   
                          </label>
                        </md-layout>
                      </md-layout>
                    </md-card-content>
                    <md-card-actions>
                      <!-- <div class="existencia" v-if="parametros.existencia_negativa === '0' && articulo.servicio == false">
                        <div class="agotado" v-if="parseFloat(articulo.existencia) <= 0">AGOTADO</div>
                        <div class="disponible" v-else>DISPONIBLE</div>
                      </div> -->
                        <!-- <md-button class="md-accent" @click.native="openDetalles(articulo)">Detalles</md-button>
                        <md-button class="md-primary md-raised" @click.native="setArticulo(articulo)" v-if ="parametros.ocultar_precios === 0 || parametros.ocultar_precios === '0' || isLogged">Agregar </md-button> -->
                    </md-card-actions>
                </md-card>
              </span>
            </md-layout>
            <md-layout md-flex="100"></md-layout>
            <md-pagination v-if="articulos.length > 0" @PAGINATION_GO_PAGE="getArticulos" :pagination="paginationOfertas"/>
        </md-layout>
        <md-layout md-flex="100" md-align="center">
          <md-button class="md-primary" id="crear" @click.native="goToCatalogo()" >Ver todos los productos</md-button>
        </md-layout>


      </md-layout>
    </md-layout>
  </div>
</template>

<script type="text/javascript">
import { toMoney } from '../../common/functions/helpers';
import mdPagination from '../../shared-components/pagination/pagination';

  export default {
    name: 'Principal',
    data() {
      return {
        resourceArticulos: this.$api.articulo(this.$resource),
        resourceDepartamentos: this.$api.departamento(this.$resource),
        pagination: {
          apply: true,
          clickable: false,
          activeClassName: "activeMine",
          type: "square",
          indicator: {
            bgColor:"rgb(0,150,136)",
            color: "white",
            showCounter: true 
          }
        },
        paginationOfertas:{
          current_page: 1,
          from: 1,
          last_page: 3,
          path: "https://ubuntu1.stshop.club:81/api/v1/articulos",
          per_page: 25,
          to: 25,
          total: 59
        },
        banners: [],
        bannersReady: false,
        categorias: [],
        categoriasReady: false,
        parametros:{},
        articulos:[],
        articuloReady: false
      };
    },
    components: {
      mdPagination,
    },
    methods: {
      toMoney,
      articuloPrecio(precio) {
        if (precio) {
          return toMoney(parseFloat(precio, 10)); 
        }
        return 0.00;
      },
      getDepartamentos() {
        this.resourceDepartamentos.buscar()
          .then((response) => {
            this.categorias = response.data.data;
            this.categoriasReady = true;
          })
          .catch((err) => {
            this.$error(this, err);
          });
      },
      goCategoria(cat){
        window.location.href = this.parametros.sitio + "/inicial" + "?departamento=" + cat.idinterno;
      },
      goArticulos(art){
        this.$router.push({ name: 'articulo', params: { idArticulo: art.idinterno } });
      },
      goToCatalogo(){
        this.$router.push({ name: 'inicial'});
      },
      getBanners(){
        this.resourceArticulos.getBanners()
          .then((response) => {
            this.banners = response.data;
            this.bannersReady = true;
          })
          .catch((err) => {
            this.$error(this, err);
          });
      },
      filtrosStr(filtros) {
        return JSON.stringify(filtros).replace(/"|{|}/g,'');
      },
      getArticulos(page) {
        const filtros = 'stshop:1,destacar:1';
        this.resourceArticulos.buscar( { page, filtros, bySubstring: this.bySubstring })
          .then((response) => {
            // this.filtros.idDepartamento = '';
            // // $route.params.idDepartamento = '';
            // this.filtros.idsubDepto = '';
            // // $route.params.idSubDepartamento = '';
            // this.bySubstring = '';
            // $route.params.descripcion = '';
            
            this.articulos = response.data.data;
            this.paginationOfertas = response.data.meta;
            if (localStorage.getItem('parametros')) {
              this.articulos.map((articulo) => {
                articulo.oferta = articulo.ofertaStShop !== null && articulo.ofertaStShop !== '' && parseFloat(articulo.ofertaStShop) !== 0;
                articulo.precioAnt = this.precioStshop(articulo, false);
                articulo.precio = this.precioStshop(articulo, articulo.oferta);
                articulo.existencia = this.getExistencia(articulo.existencias);
                articulo.cantidad = 1;
              })
            }
            this.articuloReady = true;
          })
          .catch((err) => {
            this.$error(this, err);
          });
        
      },
      precioStshopPresentacion(articulo, presentacion) {
        let precio = '';
        const usuario = localStorage.getItem('cliente') ? JSON.parse(localStorage.getItem('cliente')) : {};
        let idlistaprecio = usuario.cliente && usuario.cliente.idlistaprecio && usuario.cliente.idlistaprecio.trim() !== ''  ? usuario.cliente.idlistaprecio : 'STSHOP    ';
        if (articulo.precios) {
          this.articuloSeleccionado.precio = 0;
          while (this.articuloSeleccionado.precio == 0 || this.articuloSeleccionado.precio == undefined){
             
          articulo.precios.forEach((element) => {
            if (element.idlistaprecio === idlistaprecio) {
              if (this.articuloSeleccionado) {
                this.articuloSeleccionado.id_presentacion = presentacion;
                this.articuloSeleccionado.pIeps = articulo.ieps ? (articulo.ieps.porcentaje / 100) + 1 : 1;
                this.articuloSeleccionado.pIva = articulo.iva ? (articulo.iva.porcentaje / 100) + 1 : 1;  
                switch(presentacion) {
                  case 1:                     
                    this.articuloSeleccionado.precioN = parseFloat(element.precio1).toFixed(2); 
                    this.articuloSeleccionado.precio = (parseFloat(element.precio1).toFixed(2) * parseFloat(this.articuloSeleccionado.pIeps).toFixed(2)) * parseFloat(this.articuloSeleccionado.pIva).toFixed(2); 
                    break;
                  case 2: 
                    this.articuloSeleccionado.precioN = parseFloat(element.precio2).toFixed(2);
                    this.articuloSeleccionado.precio = (parseFloat(element.precio2).toFixed(2) * parseFloat(this.articuloSeleccionado.pIeps).toFixed(2)) * parseFloat(this.articuloSeleccionado.pIva).toFixed(2); 
                    break;
                  case 3: 
                    this.articuloSeleccionado.precioN = parseFloat(element.precio3).toFixed(2);
                    this.articuloSeleccionado.precio = (parseFloat(element.precio3).toFixed(2) * parseFloat(this.articuloSeleccionado.pIeps).toFixed(2)) * parseFloat(this.articuloSeleccionado.pIva).toFixed(2); 
                    break;
                  default: 
                    this.articuloSeleccionado.precioN = parseFloat(element.precio1).toFixed(2);
                    this.articuloSeleccionado.precio = (parseFloat(element.precio1).toFixed(2) * parseFloat(this.articuloSeleccionado.pIeps).toFixed(2)) * parseFloat(this.articuloSeleccionado.pIva).toFixed(2);
                }
                if (this.articuloSeleccionado.precio == 0){
                  idlistaprecio = 'STSHOP    ';
                }
              }
            }
          });
        }
        }
      },
      getExistencia(existencias){
        let existencia = '';
        existencias.forEach((element) => {
          if (element.idalmacen === this.parametros.almacen) {
            existencia = element.existencia
          }
        });
        return existencia;
      },
      getPrecio(articulo, idlistaprecio, oferta){
        let precio = "";
        if(!oferta){
          articulo.precios.forEach(element => {
            if (element.idlistaprecio === idlistaprecio) {
              const ieps = articulo.ieps ? articulo.ieps.porcentaje / 100 + 1 : 1;
              const iva = articulo.iva ? articulo.iva.porcentaje / 100 + 1 : 1;
              const precioIeps = parseFloat(element.precio1).toFixed(2) * ieps;
              precio =
                parseFloat(precioIeps).toFixed(2) *
                iva *
                articulo.moneda.cotizacion;
            }
          });
        } else {
          const ieps = articulo.ieps ? articulo.ieps.porcentaje / 100 + 1 : 1;
              const iva = articulo.iva ? articulo.iva.porcentaje / 100 + 1 : 1;
              const precioIeps = parseFloat(articulo.ofertaStShop).toFixed(2) * ieps;
              precio =
                parseFloat(precioIeps).toFixed(2) *
                iva *
                articulo.moneda.cotizacion;
        }
        return precio;
      },
      precioStshop(articulo, oferta) {
        let precio = '';
        
        const usuario = localStorage.getItem('cliente') ? JSON.parse(localStorage.getItem('cliente')) : {};
        let idlistaprecio = usuario.cliente && usuario.cliente.idlistaprecio ? usuario.cliente.idlistaprecio : 'STSHOP    ';

        if (articulo.precios) {
          precio = this.getPrecio(articulo, idlistaprecio, oferta);
          if (idlistaprecio !== 'STSHOP    ' && (precio === '' || precio === 0)){
            idlistaprecio = 'STSHOP    ';
            precio = this.getPrecio(articulo, idlistaprecio, oferta);
          }
        }
        return precio;
      }
    },
    mounted() {
      this.parametros = localStorage.getItem('parametros') ? JSON.parse(localStorage.getItem('parametros')) : {};  
      this.isLogged = localStorage.getItem('cliente') ? true : false;
      localStorage.setItem("ultimaPagina", 'carrito'); 
      this.getBanners();
      this.getDepartamentos();
      this.getArticulos(1);
    },
  };
</script>

<style lang="scss">
  .activeMine{
    background-color:#ED8045 !important;
  }
  .precioNormal{
    text-decoration: line-through;
    font-size: 14px;
    color: grey;
  }
  .precio{
    font-weight: bold;
    font-size: 16px;
  }
  // .articulo-card{
  //       margin:10px;
  //       width:100%;
  //       img{
  //          max-height: 130px;
  //          max-width: 130px;
           
  //       }
  //       .descripcion {
  //           // height:215px;
  //           text-align: justify;
  //           height:50px;
  //           margin-bottom:10px;
  //           .md-tooltip{
  //               max-width: 100px !important;
  //           }
  //       }
  //       .md-card-actions{
            
  //       }
  //   }
  //   #dialogDetalle{
  //     .md-dialog{
  //       width:650px;
  //       }
  //   }
  //   .precio{
  //     font-size: 18px;
  //     font-weight: bold;
  //     opacity: .8;
  //     margin-top: 20px;
  //   }
  //   .existencia {
  //     font-size:14px;
  //     font-weight: 500;
  //     text-align: center;
  //     // margin-right: auto;
  //     padding: 5px 0px;
  //     .agotado{
  //       // background-color: #FF0000;
  //       color:#FF0000;

  //     }
  //     .disponible{
  //       // background-color: #01DF01;
  //       color:#04B431;

  //     }

  //   }
</style>



// WEBPACK FOOTER //
// src/spa/principal/Principal.vue